import React from 'react'
import { useQuery } from 'react-query'
import { getCurrentUser } from '@/core/apiModules/currentUser'
import { getTeammateInvite } from '@/core/apiModules/teammateInvite'
import NewMemberRegistrationForm from '../components/NewMemberRegistrationForm'

import { parseURLParams } from '@offerzen/pinata-shame'

const NewMemberRegistrationScene = ({ location }) => {
  const { token } = parseURLParams(location.search)
  const { refetch: refetchCurrentUser } = useQuery(['currentUser'], () => getCurrentUser(), {
    refetchOnWindowFocus: false,
  })
  const { data: { result: teammateInvite = {} } = {} } = useQuery(['getTeammateInviteDetails', token], () => getTeammateInvite(token), {
    refetchOnWindowFocus: false,
    onError: error => {
      const errorData = error.response.data.result
      window.location.href = errorData.url
    },
  })

  return (
    <NewMemberRegistrationForm
      location={location}
      companyName={teammateInvite.company_name}
      email={teammateInvite.email}
      name={teammateInvite.name}
      token={token}
      refetchCurrentUser={refetchCurrentUser}
    />
  )
}

export default NewMemberRegistrationScene
